import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Box,
} from '@mui/material';

const ModalDataHoraAusencia = ({ open, onClose, onSubmit, activeAusenciaData = {} }) => {
    const [dataHora, setDataHora] = useState('');
    const [dataHoraFinal, setDataHoraFinal] = useState('');

    useEffect(() => {
        if (open) {
            const initialStart = activeAusenciaData?.dh_ausencia;
            const initialFinal = activeAusenciaData?.dh_ausencia_final;
            setDataHora(initialStart && !initialStart.startsWith('0000') ? initialStart.substring(0, 16) : '');
            setDataHoraFinal(initialFinal && !initialFinal.startsWith('0000') ? initialFinal.substring(0, 16) : '');
        }
    }, [open, activeAusenciaData]);

    const isDateOrderInvalid = !!(dataHora && dataHoraFinal && new Date(dataHoraFinal) <= new Date(dataHora));
    const isSubmitDisabled = !dataHora || !dataHoraFinal || isDateOrderInvalid;

    const handleSubmit = () => {
        if (dataHora && dataHoraFinal && !isDateOrderInvalid) {
            // Expected format is "YYYY-MM-DDTHH:mm" for datetime-local
            // Let's add seconds to match the "0000-00-00T00:00:00" backend format if it doesn't have it
            let finalStart = dataHora;
            if (finalStart.length === 16) {
                finalStart += ':00';
            }
            let finalEnd = dataHoraFinal;
            if (finalEnd.length === 16) {
                finalEnd += ':00';
            }
            onSubmit({ dh_ausencia: finalStart, dh_ausencia_final: finalEnd });
        }
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Data e Hora da Ausência</DialogTitle>
            <DialogContent>
                <Box display="flex" flexDirection="column" gap={2} mt={1}>
                    <TextField
                        label="Data e Hora de Início"
                        type="datetime-local"
                        value={dataHora}
                        onChange={(e) => setDataHora(e.target.value)}
                        fullWidth
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <TextField
                        label="Data e Hora Final"
                        type="datetime-local"
                        value={dataHoraFinal}
                        onChange={(e) => setDataHoraFinal(e.target.value)}
                        fullWidth
                        InputLabelProps={{
                            shrink: true,
                        }}
                        error={isDateOrderInvalid}
                        helperText={isDateOrderInvalid ? 'A data final deve ser posterior à data de início' : ''}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="inherit">Cancelar</Button>
                <Button onClick={handleSubmit} color="primary" variant="contained" disabled={isSubmitDisabled}>
                    Confirmar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ModalDataHoraAusencia;
